import React from 'react';
import Spacing from '../Spacing';
import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
import AboutStyle4 from '../About/AboutStyle4';
import FunFact from '../FunFact';
import AboutStyle5 from '../About/AboutStyle5';
import IconBoxStyle6 from '../IconBox/IconBoxStyle6';
import SectionHeadingStyle5 from '../SectionHeading/SectionHeadingStyle5';
import SectionHeading from '../SectionHeading';
import Marquee from '../Marquee';
import Brands from '../Brands';
import { pageTitle } from '../../helpers/PageTitle';
const funfactData = [
  {
    title: 'Satisfied Customers',
    number: '284'
  },
  {
    title: 'Energy Projects Completed',
    number: '1,108'
  },
  {
    title: 'Certified Energy Experts',
    number: '28'
  }
];

// const teamData = [
//   {
//     memberImg: '/images/studio-agency/team_1.jpeg',
//     memberName: 'Steve Njoroge',
//     memberDesignation: 'CEO & Director',
//     href: '/team/team-details',
//   },
//   {
//     memberImg: '/images/studio-agency/team_2.jpeg',
//     memberName: 'Brian Ndegwa',
//     memberDesignation: 'IT Support',
//     href: '/team/team-details',
//   }
// ];
const brandList = [
  {
    logoSrc: '/images/marketing-agency/brand_1.svg',
    logoAlt: 'Brand',
  },
  {
    logoSrc: '/images/marketing-agency/brand_2.svg',
    logoAlt: 'Brand',
  },
  {
    logoSrc: '/images/marketing-agency/brand_3.svg',
    logoAlt: 'Brand',
  },
  {
    logoSrc: '/images/marketing-agency/brand_4.svg',
    logoAlt: 'Brand',
  },
];
// const brandListDark = [
//   {
//     logoSrc: '/images/marketing-agency/brand_1_dark.svg',
//     logoAlt: 'Brand',
//   },
//   {
//     logoSrc: '/images/marketing-agency/brand_2_dark.svg',
//     logoAlt: 'Brand',
//   },
//   {
//     logoSrc: '/images/marketing-agency/brand_3_dark.svg',
//     logoAlt: 'Brand',
//   },
//   {
//     logoSrc: '/images/marketing-agency/brand_4_dark.svg',
//     logoAlt: 'Brand',
//   },
// ];

export default function AboutPage() {
  pageTitle('About');
  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <SectionHeadingStyle3
        title="Powering the Future with Renewable Energy"
        subTitle="About Us"
        variant="text-center"
        shape="shape_1"
      />
      <Spacing lg="75" md="60" />
      <AboutStyle4
        thumbnailSrc="/images/about-us/about-1.jpg"
        miniTitle="Company Info"
        title="Committed to Renewable Energy"
        subTitle="Soketry Solutions specializes in delivering cutting-edge renewable energy solutions, from solar panels to wind turbines. Our mission is to make sustainable energy accessible to all, helping to reduce carbon footprints and promote energy independence. Our expert team is dedicated to providing reliable, efficient, and innovative solutions that meet the specific needs of our clients."
        btnText="See Our Services"
        btnUrl="/service"
      />
      <Spacing lg="125" md="70" />
      <div className="container">
        <FunFact data={funfactData} />
      </div>
      <Spacing lg="125" md="70" />
      <AboutStyle5
        variant="cs_type_1"
        thumbnailSrc="/images/about-us/about-2.jpg"
        miniTitle="What We Do"
        title="Leading Renewable Energy Solutions Provider"
        subTitle="We offer a broad range of renewable energy services designed to ensure optimal performance and sustainability. Our solutions cater to both residential and commercial needs, providing everything from initial consultation and design to installation and ongoing maintenance."
        progressBarList={[
          { title: 'Solar Energy Solutions', percentage: '94' },
          { title: 'Wind Energy Systems', percentage: '96' },
          { title: 'Energy Efficiency Audits', percentage: '100' },
        ]}
        salesTitle="Impact on Sustainability"
        groth="37"
      />
      <Spacing lg="150" md="80" />
      <section className="cs_primary_bg">
        <Spacing lg="140" md="70" />
        <div className="container">
          <SectionHeadingStyle5 title="Our Process" />
          <Spacing lg="85" md="45" />
          <div className="cs_working_process_wrap cs_center">
            <div className="cs_working_process">
              <div className="cs_working_process_col">
                <IconBoxStyle6
                  bgSrc="/images/others/process_1.png"
                  iconSrc="/images/icons/search.svg"
                  title="Site Assessment"
                  subTitle="We conduct thorough site evaluations to determine the best renewable energy solutions, considering factors like solar exposure, wind patterns, and energy consumption."
                />
              </div>
              <div className="cs_working_process_col">
                <IconBoxStyle6
                  bgSrc="/images/others/process_2.png"
                  iconSrc="/images/icons/idea.svg"
                  title="Custom Design"
                  subTitle="Our experts design tailored renewable energy systems that maximize efficiency and ROI, incorporating the latest sustainable technologies."
                />
              </div>
              <div className="cs_working_process_col">
                <IconBoxStyle6
                  bgSrc="/images/others/process_3.png"
                  iconSrc="/images/icons/gear.svg"
                  title="Installation & Support"
                  subTitle="Professional installation by certified technicians, followed by comprehensive maintenance and monitoring services to ensure optimal performance."
                />
              </div>
            </div>
          </div>
        </div>
        <Spacing lg="150" md="80" />
      </section>
      <section className="cs_p76_full_width">
        <Spacing lg="143" md="75" />
        <div className="container">
          <SectionHeading
            title="Meet our experts team behind <br />the Soketry Solutions"
            subTitle="Our Team"
          />
          <Spacing lg="85" md="45" />
        </div>
        {/* <TeamSlider data={teamData} /> */}
      </section>
      <Spacing lg="135" md="70" />
      <Marquee text="Empowering the World with Sustainable Energy Solutions" />
      <Spacing lg="84" md="50" />
      <div className="container">
         <Brands data={brandList} />
      </div>
      <Spacing lg="135" md="80" />
    </>
  );
}
